const reportManualAdjustmentActions = {
  REPORT_FIN_TERMS_EDIT_INIT: 'REPORT_FIN_TERMS_EDIT_INIT',
  REPORT_FIN_TERMS_EDIT_SET: 'REPORT_FIN_TERMS_EDIT_SET',
  REPORT_FIN_TERM_PARAM_UPDATE: 'REPORT_FIN_TERM_PARAM_UPDATE',
  REPORT_FIN_TERM_FILE_UPDATE: 'REPORT_FIN_TERM_FILE_UPDATE'
};
export default reportManualAdjustmentActions;
